// T049: Create useFeed hook with T050: infinite scroll and T051: polling

import { useInfiniteQuery } from '@tanstack/react-query'
import { getAccountFriendsFeed } from '@/services/feeds/feedsClient'
import { transformFeedResponse } from '@/services/feeds/transformer'
import { queryKeys } from '@/services/queryClient'
import { Post } from '@/types/post'

interface UseFeedOptions {
  username: string
  limit?: number
  refetchInterval?: number
}

export function useFeed({ username, limit = 20, refetchInterval = 30000 }: UseFeedOptions) {
  return useInfiniteQuery({
    queryKey: queryKeys.feed(username),
    queryFn: async ({ pageParam = 0 }) => {
      const response = await getAccountFriendsFeed(username, {
        offset: pageParam,
        limit,
        bodyLength: 250,
      })

      // Extract rows from the API response structure
      const rows = response?.result?.rows || []

      const posts = transformFeedResponse(rows)

      return {
        posts,
        nextOffset: pageParam + limit,
        hasMore: posts.length === limit,
      }
    },
    getNextPageParam: (lastPage) => {
      return lastPage.hasMore ? lastPage.nextOffset : undefined
    },
    initialPageParam: 0,
    refetchInterval, // Polling for real-time updates
    staleTime: 30 * 1000, // 30 seconds
  })
}

// Helper to get all posts from infinite query
export function getAllPosts(
  data: { pages: { posts: Post[] }[] } | undefined
): Post[] {
  if (!data) return []

  return data.pages.flatMap((page) => page.posts)
}
